import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Theme store. Drives the data-theme attribute on <html>; the prototype's
 * CSS keys off [data-theme="dark"]. Persisted to localStorage so the
 * cashier's preference survives reloads.
 */

export type Theme = 'light' | 'dark';

interface ThemeState {
  theme: Theme;
  toggle: () => void;
  set: (t: Theme) => void;
}

export const useTheme = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'light',
      toggle: () => {
        const next: Theme = get().theme === 'light' ? 'dark' : 'light';
        applyToDom(next);
        set({ theme: next });
      },
      set: (t) => {
        applyToDom(t);
        set({ theme: t });
      },
    }),
    {
      name: 'pos:cashier:theme',
      onRehydrateStorage: () => (state) => {
        if (state) applyToDom(state.theme);
      },
    },
  ),
);

function applyToDom(t: Theme) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', t);
}
